import { shape, bool, string } from 'prop-types';
import { IconType, Icon } from '../asset/asset.type';
import type { CardResource as SharedCardResource } from '../../../content/types/content/resources';

export const ResourceType = shape({
    hideInHeader: bool,
    shortTitle: string,
    title: string,
    buttonLink: string,
    icon: IconType,
    shortDescription: string,
    description: string
});

export interface CardResource extends SharedCardResource {}

export interface CardResourceV2 {
    id: string;
    icon: Icon;
    title: string;
    sacHomeDescription: string;
    buttonLink: string;
    buttonText: string;
    hideInHeader: boolean;
}

export interface IconDimensions {
    height: number;
    width: number;
}
